import {inject} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import {Store} from "@ngrx/store";
import {concatLatestFrom} from "@ngrx/operators";
import {switchMap, map, filter} from "rxjs/operators";
import {AiChatActions} from "./ai-chat.actions";
import {selectAiChatConversationId} from "./ai-chat.selectors";
import {AiChatService} from "../../services/ai-chat/ai-chat.service";

export const aiChatSendMessage = createEffect(
  (actions$ = inject(Actions), aiChatService = inject(AiChatService), store = inject(Store)) => {
    return actions$.pipe(
      ofType(AiChatActions.sendMessage),
      concatLatestFrom(() => store.select(selectAiChatConversationId)),
      switchMap(([{message, context}, conversationId]) =>
        aiChatService.streamChat(message, context, conversationId).pipe(
          map(event => {
            switch (event.type) {
              case "message":
                return AiChatActions.streamChunk({text: event.text});
              case "tool_call":
                return AiChatActions.streamToolCall({tool: event.tool, status: event.status});
              case "entity_references":
                return AiChatActions.streamEntityReferences({refs: event.refs});
              case "suggested_actions":
                return AiChatActions.streamSuggestedActions({actions: event.actions});
              case "done":
                return AiChatActions.streamComplete();
              case "error":
                return AiChatActions.streamError({message: event.message});
              default:
                return undefined;
            }
          }),
          filter((action): action is NonNullable<typeof action> => action != null),
        ),
      ),
    );
  },
  {functional: true},
);
